<template>
  <b-container fluid>
    <div :class="wrapperClass" :style="backgroundImageStyle">
      <b-container v-if="!isUnlogged && !isDuplicate">
        <div class="content" :class="contentClass" :style="contentStyle">
          <slot></slot>
        </div>
      </b-container>

      <div v-else>
        <div class="content" :class="contentClass" :style="contentStyle">
          <slot></slot>
        </div>
      </div>
    </div>
</b-container>
</template>

<script>
import { getFrontOfficeHelperStyle } from '@/utils/style'

export default {
  props: {
    background: {
      type: Boolean,
      default: false
    },
    paddingContent: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      currentPage:this.$route.name,
      isUnlogged: this.$route.name === 'offline_booking_prelogged_company',
      isDuplicate: this.$route.name === 'home_booking_duplicate'
    }
  },

  computed: {
    wrapperClass () {
      return this.background ? 'hotel-background' : ''
    },
    contentClass () {
      return this.background ? 'has-background' : ''
    },
    contentStyle () {
      return this.paddingContent ? {} : { padding: '0' }
    },
    backgroundImageStyle () {
      return getFrontOfficeHelperStyle(this.background)
    }
  }
}
</script>
